module.exports = __webpack_public_path__ + "static/media/tv-retro-slash.c89a027b.svg";